<template>
  <h2 class="pb-2 border-bottom">Facial Harmonization Services</h2>
  <div class="fh-flex">
    <div class="fh-content">
      <p>Facial harmonization is a highly sought-after aesthetic treatment that enhances facial symmetry and balance using minimally invasive procedures.</p>

      <h5>Key Treatments for Facial Harmonization</h5>
  <ul>
    <li>Botox & Neuromodulators – Softens expression lines (forehead, crow’s feet, frown lines)</li>
    <li>Dermal Fillers (Hyaluronic Acid, Radiesse, Sculptra) – Contours cheeks, jawline, and lips</li>
    <li>Chin & Jawline Contouring – Enhances definition and corrects asymmetry</li>
    <li>Lip Enhancement – Natural or voluminous lip augmentation</li>
    <li>Non-Surgical Rhinoplasty – Filler to correct bumps and refine nose shape</li>
    <li>Temple & Under-Eye Filler – Treats hollowing and dark circles for a youthful look</li>
    <li>Cheekbone Augmentation – Adds structure and lifts mid-face</li>
    <li>Skin Boosters (Profhilo, PRP, Exosomes) – Improves skin hydration and texture</li>
    <li>PDO Threads (Optional) – Lifts sagging skin without surgery</li>
  </ul>
  <p>💡 Combination treatments create a more natural, balanced appearance rather than focusing on one feature alone.</p>

  <h5>Facial Harmonization Procedure Overview</h5>
  <ul>
    <li>Consultation & Facial Analysis
      <ul>
        <li>Assess patient goals and facial proportions</li>
        <li>Identify areas needing volume, structure, or contouring</li>
        <li>Develop a personalized treatment plan</li>
      </ul>
    </li>
    <li>Procedure & Technique
      <ul>
        <li>Local anesthesia or numbing cream (if needed)</li>
        <li>Precise injection techniques for natural results</li>
        <li>Immediate improvement with minimal downtime</li>
      </ul>
    </li>
    <li>Post-Treatment Care & Follow-up
      <ul>
        <li>Provide aftercare instructions (avoid pressure, minimize swelling)</li>
      </ul>
    </li>
  </ul>
    </div>
    <div class="fh-videos">
      <iframe width="320" height="568" style="max-width:100%; border-radius: 12px; box-shadow: 0 4px 24px rgba(0,0,0,0.08); margin-bottom: 1.5rem;" src="https://www.youtube.com/embed/dsy8tUMNyIs" title="YouTube Shorts: Facial Harmonization 1" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
      <iframe width="320" height="568" style="max-width:100%; border-radius: 12px; box-shadow: 0 4px 24px rgba(0,0,0,0.08);" src="https://www.youtube.com/embed/LM2IEIQ-mC8" title="YouTube Shorts: Facial Harmonization 2" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FacialHarmonizationContentEn'
};
</script>

<style scoped>
.fh-flex {
  display: flex;
  gap: 2rem;
  flex-wrap: wrap;
  align-items: flex-start;
  margin-top: 1.5rem;
}
.fh-content {
  flex: 1 1 340px;
  min-width: 0;
}
.fh-videos {
  flex: 0 0 340px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}
@media (max-width: 900px) {
  .fh-flex {
    flex-direction: column;
    gap: 1.5rem;
  }
  .fh-videos {
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
    margin: 0 auto;
    gap: 1rem;
  }
  .fh-videos iframe {
    width: 48vw;
    height: 270px;
    min-width: 160px;
    max-width: 100%;
  }
}
</style>
